import React, { useState, useEffect } from 'react';
import {
    Box,
    Button,
    AppBar,
    Toolbar,
    Grid,
    Typography,
    Modal,
    LinearProgress,
    CircularProgress,
    TextField, FormControl, InputLabel, Select, MenuItem
} from '@mui/material';
import { Add } from '@mui/icons-material';
import HeaderAvatar from "../components/HeaderAvatar";
import PresentationEditor from "../components/PresentationEditor";
// import { usePermissions } from "../components/PermissionsContext";
// import { fetchProjects, uploadPresentation, getSlides, getChapters, addChapter, getChapterSlides, addSlideToChapter, fetchProject } from '../services/api';
import { useNavigate, useParams } from 'react-router-dom';
import {
    addPresentation,
    addProduct,
    fetchPresentation,
    fetchPresentations, fetchProducts,
    uploadPresentationArchive
} from "../services/api";
import {Presentation, Product} from "../services/types";

interface Slide {
    id: number;
    name: string;
    preview: string;
    // Add other properties as needed
}


interface PresentationsListProps {
    presentations: Presentation[];
    onPresentationClick: (presentation: Presentation) => void;
}

interface UploadModalProps {
    open: boolean;
    onClose: () => void;
    progress: number;
}
interface PresentationEditorProps {
    presentation: Presentation;
    slides: Slide[];
    onUpload: (file: File) => Promise<void>;
}


const Presentations: React.FC = () => {
    // const { permissions } = usePermissions();
    const [presentations, setPresentations] = useState([]);
    const [slides, setSlides] = useState([]);
    // const [chapters, setChapters] = useState<Chapter[]>([]);
    const [currentPresentation, setCurrentPresentation] = useState<Presentation | null>(null);
    const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [progressText, setProgressText] = useState<string>('Пожалуйста, дождитесь завершения загрузки');
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [createName, setCreateName] = useState('');
    const [createProduct, setCreateProduct] = useState<string | number | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [products, setProducts] = useState<Product[]>([]);


    const fetchProductsData = async () => {
        try {
            const data = await fetchProducts(1);
            setProducts(data.items);
        } catch (error) {
            console.error('Error fetching products:', error);
        } finally {
        }
    };

    useEffect(() => {
        loadPresentations();
        fetchProductsData();
    }, []);


    const navigate = useNavigate();
    const { id } = useParams();

    useEffect(() => {
        if (id) {
            fetchPresentation(id).then(setCurrentPresentation);
        }else{
            setCurrentPresentation(null)
        }
    }, [id]);

    const handlePresentationClick = (presentation: Presentation) => {
        setCurrentPresentation(presentation);
        navigate(`/presentations/${presentation.id}`);
    };

    const loadPresentations = async () => {
        const data = await fetchPresentations(1, 100);
        setPresentations(data.items);
    };

    const PresentationsList: React.FC<PresentationsListProps> = ({ presentations, onPresentationClick }) => (
        <Box className='presentationItems'>
            {presentations.map((presentation) => (
                <Box className='presentationItem' key={presentation.id} onClick={() => onPresentationClick(presentation)}>
                    {presentation.picture!==null && presentation.picture.id !== 1 ?
                        <Box>
                            <img src={'https://stage.selfdetailing.ru'+presentation?.picture.raw} alt={presentation.picture.raw}/>
                        </Box>
                        : null}
                    <Box className='presentationItemText'>
                        {presentation.title}
                    </Box>
                </Box>
            ))}
        </Box>
    );

    const handleCreate = async () => {
        try {
            const addData = {
                title: createName,
                description: "",
                pictureId: 1,
                status: 'ACTIVE',
                productId: createProduct
            }
            await addPresentation(addData);
            setIsCreateModalOpen(false);
            setCreateName('');
            loadPresentations();
        } catch (error) {
            console.error('Error inviting team member:', error);
            setError('Failed to send invitation');
        }
    };


    const handleUploadPresentation = async (file: File) => {
        if (!currentPresentation) {
            console.error('No presentation selected');
            return;
        }

        setIsUploadModalOpen(true);
        try {
            const response = await uploadPresentationArchive(currentPresentation.id, file, (progress) => {
                setUploadProgress(progress);
                if (progress == 100){
                    setProgressText("Идет распаковка и оптимизация")
                }
            });
            fetchPresentation(id).then(setCurrentPresentation);
        } catch (error) {
            console.error('Error uploading presentation:', error);
            // Handle error (e.g., show an error message to the user)
        } finally {
            setProgressText("Пожалуйста, дождитесь завершения загрузки")
            setIsUploadModalOpen(false);
            setUploadProgress(0);
        }
    };
    const handleDeleteSlidePresentation = async () => {
        setCurrentPresentation(null)
        await fetchPresentation(id).then(setCurrentPresentation);
    };
    const handleUpdateSlidePresentation = async () => {
        setCurrentPresentation(null)
        await fetchPresentation(id).then(setCurrentPresentation);
    };

    return (
        <Box>
            <AppBar position="static">
                <Toolbar className='toolbar'>
                    <Box className='toolbarTitle'>{currentPresentation ?
                        <Box>{currentPresentation.title}</Box>
                        :
                        <Box>Презентации <span>{presentations.length}</span></Box>
                    }</Box>
                    <Button className="addToobarBtn" variant="contained" onClick={() => {}}><Add /></Button>
                    <HeaderAvatar/>
                </Toolbar>
            </AppBar>

            {/* Основной контент */}
            {!currentPresentation ? (
                <>
                    <Box className='topButtonsContainer hideMPageButtons'>
                        <Box></Box>
                        <Button className='topButtonsAdd' variant="outlined" onClick={() => setIsCreateModalOpen(true)}><Add /> Добавить презентацию</Button>
                    </Box>
                    <PresentationsList presentations={presentations} onPresentationClick={handlePresentationClick} />
                </>
            ) : (
                <PresentationEditor
                    presentation={currentPresentation}
                    onUpload={handleUploadPresentation}
                    onDelete={handleDeleteSlidePresentation}
                    onUpdate={handleUpdateSlidePresentation}
                />
            )}


            {/* Модальное окно загрузки */}
            <Modal open={isUploadModalOpen} onClose={() => setIsUploadModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Box sx={{ /* стили */ }}>
                            <Typography sx={{mb: 3}}>{progressText}</Typography>
                            {uploadProgress === 100 ?
                                <Box sx={{display: 'flex', justifyContent: 'center'}}>
                                    <CircularProgress style={{color: '#3a485b'}}/>
                                </Box>
                                :
                                <Box>
                                    <LinearProgress variant="determinate" value={uploadProgress}/>
                                    <Typography>{uploadProgress}%</Typography>
                                </Box>
                            }
                        </Box>
                    </Box>
                </Box>
            </Modal>

            {/* Модальное окно добавления */}
            <Modal open={isCreateModalOpen} onClose={() => setIsCreateModalOpen(false)}>
                <Box sx={{flexGrow:1, minHeight: '100vh', display: 'flex', justifyContent:'center', alignItems:'center'}}>
                    <Box className="modalFiled" sx={{ position: 'relative', bgcolor: 'background.paper', boxShadow: 24, maxWidth: 600 }}>
                        <Typography variant="h6">Создание презентации</Typography>
                        <TextField
                            label="Название"
                            value={createName}
                            onChange={(e) => setCreateName(e.target.value)}
                            fullWidth
                            type="text"
                            margin="normal"
                        />
                        <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
                            <InputLabel id="project-select-label">Выберите продукт</InputLabel>
                            <Select
                                labelId="project-select-label"
                                id="project-select"
                                value={createProduct}
                                label="Выберите проект"
                                onChange={(e) => setCreateProduct(e.target.value)}
                            >
                                {products.map((product) => (
                                    <MenuItem key={product.id} value={product.id}>
                                        {product.title}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                        <Box sx={{display:'flex', justifyContent: 'space-between', mt: 2, gap: 2}}>
                            <Button className="blueModalButton" variant="contained" onClick={handleCreate}>
                                Создать
                            </Button>
                            <Button className="blueModalButton" variant="outlined" onClick={()=>setIsCreateModalOpen(false)} style={{color: 'red', borderColor: 'red'}}>
                                Отмена
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>

        </Box>
    );
};

export default Presentations;
